export const isString = value => {
  return typeof value === 'string'
}

export const isNumber = value => {
  return typeof value === 'number'
}
